<h1 mat-dialog-title class="mbp-confirm-dialog__title">{{ data.title }}</h1>
<div mat-dialog-content class="mbp-confirm-dialog__content medicine-dosage-dialog">
  @if (data.message && data.message !== data.title) {
    <p class="medicine-dosage-dialog__intro">{{ data.message }}</p>
  }
  <form [formGroup]="medicineDosagePackageTypeForm" class="package-edit-form">
    <div class="package-edit-form__field">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Label name</mat-label>
        <input required formControlName="labelName" type="text" matInput>
        @if (medicineDosagePackageTypeForm.get('labelName')?.invalid) {
          <mat-error>
            Label name is invalid {{labelNameExceeds25Chars ? ": Max 25 characters allowed" : ""}}
          </mat-error>
        }
        <mat-hint>Maximum of 25 characters</mat-hint>
      </mat-form-field>
    </div>

    <div class="package-edit-form__field">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Price</mat-label>
        <input required formControlName="price" type="number" matInput>
        @if (medicineDosagePackageTypeForm.get('price')?.invalid) {
          <mat-error>
            Price is invalid
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="package-edit-form__field">
      <core-package-type-search-field
        [control]="medicineDosagePackageTypeForm.controls['packageType']">
      </core-package-type-search-field>
    </div>

    <div class="package-edit-form__field">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Quantity</mat-label>
        <input required formControlName="containedQuantity" type="number" step="0.01" matInput>
        @if (medicineDosagePackageTypeForm.get('containedQuantity')?.invalid) {
          <mat-error>
            Quantity is invalid
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="package-edit-form__field">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Units per pack</mat-label>
        <input required formControlName="unitsPerPack" type="number" min="1" step="1" matInput>
        <mat-hint>e.g. 1 for a 5ml bottle, 5 for a 5 × 1ml pack</mat-hint>
        @if (medicineDosagePackageTypeForm.get('unitsPerPack')?.invalid) {
          <mat-error>
            Units per pack must be 1 or more
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="package-edit-form__field">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Minimum order qty</mat-label>
        <input formControlName="minOrderQty" type="number" min="1" step="1" matInput>
        <mat-hint>Leave empty if there is no minimum</mat-hint>
      </mat-form-field>
    </div>

    <div class="package-edit-form__field package-edit-form__field--wide">
      <core-sage-item-code-field
        [sageItemId]="medicineDosagePackageType?.sage_item_id ?? null">
      </core-sage-item-code-field>
    </div>
  </form>
</div>
<div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
  <button type="button" mat-stroked-button [mat-dialog-close]="false">Cancel</button>
  <button type="button" [disabled]="!medicineDosagePackageTypeForm.valid" mat-flat-button color="primary" (click)="save()">
    Save
  </button>
</div>
